import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { API_URI } from '../../environments/environment';
import { AsistenteMensaje } from '../models/AsistenteMensaje';

@Injectable({
  providedIn: 'root'
})
export class AsistenteService {
  private http = inject(HttpClient);
  private readonly API_URI: string = API_URI + 'app';

  consulta(mensaje: string, historial: AsistenteMensaje[]): Observable<{ respuesta: string; historial: AsistenteMensaje[] }> {
    return this.http
      .post<{ respuesta: string; historial: AsistenteMensaje[] }>(`${this.API_URI}/asistente/consulta`, { mensaje, historial })
      .pipe(
        catchError((err) => {
          console.error('Error al consultar a LIA:', err);
          return throwError(() => err);
        })
      );
  }

  // Confirma si LIA está operativa (OpenAI configurado del lado del backend), para
  // decidir si mostrar el ícono del chat.
  estado(): Observable<{ disponible: boolean }> {
    return this.http.get<{ disponible: boolean }>(`${this.API_URI}/asistente/estado`);
  }
}
